namespace Riepiloghi.Administration {
    export interface UserRoleListRequest extends Serenity.ServiceRequest {
        UserID?: number;
    }
}

